import { useMemo } from 'react';
import { deliveryIdFromMission, REPLAY_PASS_COST } from '../../../domain';
import { useAppStore } from '../../store/appStore';
import {
  createDeliveryResultScreenModel,
  type DeliveryResultScreenProps,
} from './DeliveryResultScreenModelScreen';
import { DeliveryResultScreenController } from './DeliveryResultScreenController';
import { DeliveryResultScreenView } from './DeliveryResultScreenView';

export type { DeliveryResultScreenProps } from './DeliveryResultScreenModelScreen';

export function DeliveryResultScreen(props: DeliveryResultScreenProps = {}) {
  const playerEconomy = useAppStore((s) => s.playerEconomy);
  const passesBalance = useAppStore((s) => s.passesBalance);
  const orderIndex = props.orderIndex ?? 0;
  const canRestart =
    props.canRestart !== false && passesBalance >= REPLAY_PASS_COST;

  const rating = useMemo(() => {
    if (props.rating != null) {
      return props.rating;
    }
    if (props.giantId == null) {
      return null;
    }
    const deliveryId = deliveryIdFromMission({
      giantId: props.giantId,
      orderIndex,
    });
    const entry = (playerEconomy.deliveryHistory ?? []).find(
      (e) => e.deliveryId === deliveryId,
    );
    return entry?.lastRating ?? null;
  }, [playerEconomy.deliveryHistory, props.giantId, props.rating, orderIndex]);

  const model = createDeliveryResultScreenModel({
    ...props,
    orderIndex,
    rating,
    canRestart,
  });
  const controller = new DeliveryResultScreenController(model);

  return <DeliveryResultScreenView model={model} controller={controller} />;
}
